import React from "react";
import styled from "styled-components";
import axios from "axios";
import { Message } from "element-react";

export default function Modal({
  isMulti = false,
  approvedProjectList,
  icon,
  title,
  text,
  filteredItems,
  btnGroup,
  closeModal,
  confirmModal,
}) {
  const [listCheck, setListCheck] = React.useState([]);
  
  const onClose = (idx) => {
    setListCheck((listCheck) => [...listCheck, idx]);
  };

  return (
    <>
      {isMulti ? (
        approvedProjectList &&
        approvedProjectList.length === listCheck.length ? (
          ""
        ) : (
          <ModalWrapper>
            <MultiModalContainer>
              {approvedProjectList &&
                approvedProjectList.length > 0 &&
                approvedProjectList.map((r, idx) => (
                  <ModalContent
                    key={idx}
                    className={listCheck.includes(idx) ? "hide" : ""}
                  >
                    <ModalHeader>
                      <InnerHead>
                        {icon && (
                          <img
                            className="alarm-icon"
                            src="/images/ctors/icon/error-icon.png"
                            alt="error-icon"
                          />
                        )}
                        <h1>{title}</h1>
                      </InnerHead>
                      <button onClick={() => onClose(idx)}>
                        <img
                          className="close-btn"
                          src="/images/ctors/icon/close-icon.png"
                          alt="닫기"
                        />
                      </button>
                    </ModalHeader>
                    <ModalBody>
                      <p>
                        {filteredItems ? (
                          <>
                            <strong>
                              [{r.userName}]
                            </strong>
                            사용자의 {" "}
                            <strong>
                              [
                              {
                                filteredItems.find((item) => item.id === r.id)
                                  ?.name
                              }
                              ]
                            </strong>{" "}
                            프로젝트의 모니터링 신청이 접수되었습니다.
                            승인하시겠습니까?
                          </>
                        ) : (
                          "해당 프로젝트를 모니터링 하고자 하는 사용자가 존재합니다. 모니터링을 승인하시겠습니까?"
                        )}
                      </p>
                      {btnGroup && (
                        <BtnGroup>
                          <button
                            onClick={() => {
                              Message({
                                type: "info",
                                iconClass: "cancel",
                                message: "승인이 보류되었습니다.",
                              });
                              onClose(idx);
                            }}
                          >
                            보류
                          </button>
                          <button
                            onClick={() => {
                              axios
                                .patch(
                                  `/cst/api/constructor-plant/approve-user-project/${r.id}`
                                )
                                .then(() => {
                                  Message({
                                    type: "success",
                                    iconClass: "success",
                                    message: "승인 되었습니다.",
                                  });
                                  onClose(idx);
                                })
                                .catch((error) => {
                                  console.error(error);
                                  Message({
                                    type: "error",
                                    iconClass: "cancel",
                                    message: "승인에 실패했습니다.",
                                  });
                                });
                            }}
                          >
                            승인
                          </button>
                        </BtnGroup>
                      )}
                    </ModalBody>
                  </ModalContent>
                ))}
            </MultiModalContainer>
          </ModalWrapper>
        )
      ) : (
        <ModalWrapper>
          <SingleModalContainer>
            <ModalHeader>
              <InnerHead>
                {icon && (
                  <img
                    className="alarm-icon"
                    src="/images/ctors/icon/error-icon.png"
                    alt="error-icon"
                  />
                )}
                <h1>{title}</h1>
              </InnerHead>
              <button onClick={closeModal}>
                <img
                  className="close-btn"
                  src="/images/ctors/icon/close-icon.png"
                  alt="닫기"
                />
              </button>
            </ModalHeader>
            <ModalBody>
              <p>{text}</p>
              {btnGroup && (
                <BtnGroup>
                  <button onClick={closeModal}>아니요</button>
                  <button onClick={confirmModal || closeModal}>예</button>
                </BtnGroup>
              )}
            </ModalBody>
          </SingleModalContainer>
        </ModalWrapper>
      )}
    </>
  );
}

const ModalWrapper = styled.div`
  &::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(23, 23, 23, 0.25);
    z-index: 0;
  }
`;
const SingleModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 5px;
  padding: 24px;
`;
const MultiModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  max-height: 90vh;
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Webkit */
  }
`;
const ModalContent = styled.div`
  display: block;
  width: 340px;
  background: #fff;
  border-radius: 5px;
  padding: 24px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  &.hide {
    display: none;
  }
`;
const ModalHeader = styled.div`
  font-size: 0;
  h1 {
    font-size: 18px;
    font-weight: bold;
    display: inline-block;
    vertical-align: middle;
  }
  img {
    display: inline-block;
    vertical-align: middle;
    object-fit: contain;
  }
  .alarm-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .close-btn img {
    width: 100%;
    height: 100%;
  }
  button {
    display: inline-block;
    vertical-align: middle;
    width: 24px;
    height: 24px;
    background: transparent;
    border: none;
  }
`;
const InnerHead = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 24px);
`;
const ModalBody = styled.div`
  padding-top: 20px;
  p {
    font-size: 15px;
    color: #4b515b;
    line-height: 1.6;
  }
`;
const BtnGroup = styled.div`
  padding-top: 25px;
  button {
    width: 140px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 5px;
    padding: 10px 0;
    &:first-child {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &:last-child {
      color: #fff;
      background-color: var(--secondary-500);
      border: 1px solid var(--secondary-500);
      margin-left: 10px;
    }
  }
`;
